// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2Ylox","rootCenter":"LoadMoreObserver_rootCenter__2QO2k","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__17oxX"};